module.exports = __webpack_public_path__ + "img/karriere.e4ecf868.png";